(function() {
  'use strict';

  angular
    .module('salt', [
        'ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ngRoute',
        'ui.bootstrap',
        'toastr',
        'textAngular',
        'angular-images-loaded',
        'as.sortable',
        'iso.directives',
        'ngStorage',
        'ngMeta'
    ]);

})();

'use strict';

angular.module('salt')
  .controller('NavbarCtrl', function ($scope, $http, $route, $routeParams, AppSettings, $log, adminService, $sessionStorage) {

    //$log.log($route.current.$$route);

    if($(".nav").hasClass('open')) {
      $('.nav').removeClass('open');
      $('.nav').slideToggle(400);
    }

    $('.nav a').removeClass('active');

    $scope.$storage = $sessionStorage;

    //get menu content
    $http.get(AppSettings.apiUrl + 'pages').
      success(function(data, status, headers, config) {
        $scope.$storage.menu = data.filter(function(index, elem) {
            return data[elem].template == 'page' && data[elem].title != '';
        });

        $scope.$storage.menu.sort(function(a,b){
            return a.id < b.id;
        })
    });

    $scope.toggleMenu = function() {
        angular.element('.nav').slideToggle();
    }

  });

'use strict';

angular.module('salt')
  .factory('adminService', function (AppSettings, $http, $timeout) {

    var page = {
          id: '',
          url: '',
          title: '',
          parent: '',
          fields: [],
          children: []
        },
        pageChild = {
          id: '',
          url: '',
          title: '',
          template: 'page',
          parent: '',
          fields: [],
          children: []
        },
        content = {
          id: '',
          page_id: '',
          title: '',
          image_url: '',
          short_text: '',
          text: '',
          draft: true
        };


    function saveForm(which, data, accessToken) {
      return $http.post(AppSettings.apiUrl + which, {accessToken: accessToken, data: data});
    }

    function removeForm(which, objectId, accessToken) {

      return $http.delete(AppSettings.apiUrl + which, {params: {accessToken: accessToken, id: objectId}});
    }


    function newPage() {
      return angular.copy(page);
    }

    function newContent() {
      return angular.copy(content);
    }


    function sortProjects(data, accessToken) {
      return $http.post(AppSettings.apiUrl + 'sortProjects', {accessToken: accessToken, data: data});
    }


    return {
      newPage: newPage,
      newContent: newContent,
      saveForm: saveForm,
      removeForm: removeForm,
      sortProjects: sortProjects
    };
  });

'use strict';

angular.module('salt')
  .controller('TagCtrl', function ($scope, $http, $route, $routeParams, AppSettings, $log, $timeout, adminService, $window, ngMeta) {
    $scope.action = $route.current.$$route.action;
    $scope.tag = $route.current.params.tag;

    $scope.menu = [];
    $scope.showAdmin = AppSettings.showAdmin;


    $scope.toggleMenu = function() {
        angular.element('.nav').slideToggle();
    }

    //get page info
    $http.get(AppSettings.apiUrl + 'pages/'+$scope.tag).
      success(function(data, status, headers, config) {
        $scope.projects = data;
        //get menu content
        $http.get(AppSettings.apiUrl + 'pages').
          success(function(data, status, headers, config) {
            $scope.menu = _.where(data, {parent: "1"});
        });
    });



  })
  .directive('resize', function ($window) {
    return function (scope, element) {
        var w = angular.element($window);
        scope.getWindowDimensions = function () {
            return {
                'h': w.height(),
                'w': w.width()
            };
        };
        scope.$watch(scope.getWindowDimensions, function (newValue, oldValue) {
            scope.windowHeight = newValue.h;
            scope.windowWidth = newValue.w;

            scope.style = function () {
                return {
                    'height': (newValue.h) + 'px',
                    'width': (newValue.w) + 'px'
                };
            };

        }, true);

        w.bind('resize', function () {
            scope.$apply();
        });
    }
  });

'use strict';

angular.module('salt')
  .controller('RentalCtrl', function ($scope, $http, $route, $routeParams, AppSettings, $log, $timeout, adminService, ngMeta) {
    $scope.action = $route.current.$$route.action;
    $scope.pageUri = $route.current.params.project;
    $scope.user = {accessToken: true};
    $scope.menu = [];
    $scope.showAdmin = AppSettings.showAdmin;


    if($("body").hasClass('vegas-container')) $("body").vegas('destroy');

    $('.nav a').removeClass('active');
    $('.rental').addClass('active');

    if($(".nav").hasClass('open')) {
      $('.nav').removeClass('open');
      $('.nav').slideToggle(400);
    }

    //get page info
    var pageUrl = encodeURIComponent(encodeURIComponent('/rental'));
    $http.get(AppSettings.apiUrl + 'page/'+pageUrl).
      success(function(data, status, headers, config) {
        $scope.page = data;
        ngMeta.setTitle($scope.page.fields.metaTitle);
        ngMeta.setTag('description', $scope.page.fields.metaDescription);
        //get menu content
        $http.get(AppSettings.apiUrl + 'pages').
          success(function(data, status, headers, config) {
            $scope.menu = _.where(data, {parent: '1'});
        });
    });

    $scope.toggleMenu = function() {
        angular.element('.nav').slideToggle();
    }


    function showLogo(){
      $('.logo').fadeIn('400', function() {
      });
    }

    var timeoutid = 0;
    $("body").mousemove(function() {
        clearTimeout(timeoutid);
        if(timeoutid != 0) $('.logo').fadeOut('400');
        timeoutid = setTimeout(showLogo, 5000);
    });



    //Admin part

    $scope.adminFormSave = function(which, draft) {

      var data = $scope[which];
      $log.log(data);
      data.draft = !!draft;

      var whichSave = which;

      //var loader = angular.element('.admin-form .actions, .admin-form .loader').toggleClass('hidden');

      adminService.saveForm(whichSave, data, $scope.user.accessToken).success(function(savedObject) {
        $scope[which] = savedObject;
      });

    }
  })
  .directive('compile',function($compile, $timeout){
    return{
        restrict:'A',
        link: function(scope,elem,attrs){
            $timeout(function(){
                $compile(elem.contents())(scope);
            });
        }
    };
  });

'use strict';

angular.module('salt')
  .controller('ProjectCtrl', function ($scope, $http, $route, $routeParams, AppSettings, $log, $timeout, adminService) {
    $scope.action = $route.current.$$route.action;
    $scope.pageUri = $route.current.params.project;
    $scope.user = {accessToken: true};
    $scope.showAdmin = AppSettings.showAdmin;


    //get page info
    var pageUrl = encodeURIComponent(encodeURIComponent('/project/' + $scope.pageUri));
    $http.get(AppSettings.apiUrl + 'page/'+pageUrl).
      success(function(data, status, headers, config) {
        $scope.page = data;
        $log.log($scope.page);
        //if no images load slider directly
        if($scope.page.content.length == 0) {
         $scope.toggle = true;
         var owl = $('.owl-carousel');

         if(typeof owl.data('owlCarousel') != 'undefined'){
             owl.data('owlCarousel').destroy();
             owl.removeClass('owl-carousel');
         }

          owl.owlCarousel({
              margin:1,
              loop:false,
              nav: true,
              navText: ['-','+'],
              autoplay: false,
              autoplayTimeout: 7000,
              autoWidth:true,
              lazyLoad: true,
              smartSpeed: 1000,
              onInitialized: function () {
              }
            });
        }
    });



    $scope.dropzoneConfig2 = {
      parallelUploads: 3,
      maxFileSize: 30,
      url: AppSettings.apiUrl + 'file-upload',
      addedfile: function(file) {
        //file.previewElement = Dropzone.createElement(this.options.previewTemplate);
      },
      thumbnail: function(file, dataUrl) {
        var elDropzone = angular.element('.thumbImage');
        elDropzone.css('background-url', dataUrl);
      },
      success: function(file, response) {
        angular.element('.form-thumb').val(response.url);
        $scope.page.fields['image'] = response.url;
        $scope.apply();
        angular.element('.thumbImage').css('background-image', 'url('+response.url+')');
      }
    };

    $scope.dragControlListeners = {
        orderChanged: function(event) {
          console.log('moved');
        }
    };

    $('#loaderBar').css({
      'opacity': '1',
      'width': '0%'
    });

    var loadedImages = 0;

    $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
      $('.owl-carousel').imagesLoaded()
        .always( function( instance ) {
          $('#loaderBar').fadeOut(400);
          $('#projectTitle').fadeIn(400);

        })
        .done( function( instance ) {
          console.log('all images successfully loaded');
          loadedImages = 0;
          console.log('setting up carousel..');
           var owl = $('.owl-carousel');
           if(typeof owl.data('owlCarousel') != 'undefined'){
               owl.data('owlCarousel').destroy();
               owl.removeClass('owl-carousel');
           }

          owl.owlCarousel({
              margin:1,
              loop: true,
              nav: true,
              navText: ['-','+'],
              autoplay: false,
              autoplayTimeout: 7000,
              autoWidth:true,
              lazyLoad: true,
              smartSpeed: 1000,
              onInitialized: function () {
                /*$('#pictures .owl-carousel')
                  .css({
                    'height': minHeight+'px',
                    'overflow': 'hidden'
                  })
                  .animate({opacity: 1}, 1000);
                    $('#pictures').addClass('loaded');*/
                }
            }
          );
        })
        .fail( function() {
          console.log('all images loaded, at least one is broken');
        })
        .progress( function( instance, image ) {
            loadedImages++;
            $('#loaderBar').css('width', loadedImages/$scope.page.content.length*100+'%');
        });

    });


    //Admin part
    $scope.dropzoneConfig = {
      parallelUploads: 3,
      maxFileSize: 30,
      url: AppSettings.apiUrl + 'file-upload',
      addedfile: function(file) {
        file.previewElement = Dropzone.createElement(this.options.previewTemplate);
      },
      thumbnail: function(file, dataUrl) {
        var elDropzone = angular.element('.uploadPreview');
        //elDropzone.find('img').remove();
        //angular.element('<img/>').attr('src', dataUrl).appendTo(elDropzone);
        //$log.log('here' + dataUrl);
      },
      success: function(file, response) {
        angular.element('.form-thumb').val(response.url);
        var item = {
          image_url: response.url
        }
        $scope.page.content.push(item);
        angular.element('.thumb-dz').css('background-image', 'url('+response.url+')');
        $scope.$apply();
      }
    };


    $scope.deleteContent = function(id){
      adminService.removeForm('content',id,$scope.accessToken).success(function(data){
        if(data) location.reload();
          else $log.error('nope');
      })
    };

    $scope.deletePage = function(id){
      adminService.removeForm('page',id,$scope.accessToken).success(function(data){
        if(data) window.location.replace("#" + $scope.page.parent_url);
          else $log.error('nope');
      })
    };

    $scope.adminFormSave = function(which, draft) {

      var data = $scope[which];
      $log.log(data);
      data.draft = !!draft;

      var whichSave = which;

      //var loader = angular.element('.admin-form .actions, .admin-form .loader').toggleClass('hidden');


      adminService.saveForm(whichSave, data, $scope.user.accessToken).success(function(savedObject) {
        $scope[which] = savedObject;
        location.reload();
      });

    }
  })
  .directive('onFinishRender', function ($timeout) {
      return {
          restrict: 'A',
          link: function (scope, element, attr) {
              if (scope.$last === true) {
                  $timeout(function () {
                      scope.$emit('ngRepeatFinished');
                  });
              }
          }
      }
  })
  .directive('compile',function($compile, $timeout){
    return{
        restrict:'A',
        link: function(scope,elem,attrs){
            $timeout(function(){
                $compile(elem.contents())(scope);
            });
        }
    };
  });
/*
  .directive('resize', function ($window) {
    return function (scope, element) {
        var w = angular.element($window);
        scope.getWindowDimensions = function () {
            return {
                'h': w.height(),
                'w': w.width()
            };
        };
        scope.$watch(scope.getWindowDimensions, function (newValue, oldValue) {
            scope.windowHeight = newValue.h;
            scope.windowWidth = newValue.w;

            scope.style = function () {
                return {
                    'height': (newValue.h) + 'px',
                    'width': (newValue.w) + 'px'
                };
            };

        }, true);

        w.bind('resize', function () {
            scope.$apply();
        });
    }
  })*/

'ue strict';

angular.module('salt')
  .controller('PageCtrl', function ($scope, $http, $route, $routeParams, AppSettings, $log, $timeout, adminService, $window, ngMeta) {
    $scope.action = $route.current.$$route.action;
    $scope.page = $route.current.params.page;

    $('.page-'+ $scope.id).addClass('active');
    $scope.showAdmin = AppSettings.showAdmin;

    $scope.menu = [];

    $scope.user = {accessToken: true};

    $scope.pageChild = {
      url: '',
      title: '',
      template: 'project',
      parent: '',
      fields: {},
      children: [],
      content: [],
      tags: ''
    };

    if($("body").hasClass('vegas-container')) $("body").vegas('destroy');

    //get page info
    var pageUrl = encodeURIComponent(encodeURIComponent('/page/' + $scope.page));
    $http.get(AppSettings.apiUrl + 'page/'+pageUrl).
      success(function(data, status, headers, config) {
        $scope.page = data;
        $scope.pageChild.parent = $scope.page.id;
        ngMeta.setTitle($scope.page.fields.metaTitle);
        ngMeta.setTag('description', $scope.page.fields.metaDescription);
        //get menu content
        $http.get(AppSettings.apiUrl + 'pages').
          success(function(data, status, headers, config) {
            $scope.menu = _.where(data, {parent: $scope.page.parent});
        });
    });

    $scope.closeProject = function(project) {
        angular.element('.projectContainer').hide();
    }

    $scope.toggleMenu = function() {
        angular.element('.nav').slideToggle();
    }


    function isScrolledIntoView(elem) {
        var $elem = $(elem);
        var $window = $(window);

        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();
        //&& (elemBottom >= docViewTop)
        return ( ((elemTop <= (docViewBottom-100)) && (elemBottom >= docViewTop)) );
    }



    $scope.dragControlListeners = {
        orderChanged: function(event) {
          $log.log($scope.page.children);
          adminService.sortProjects($scope.page.children,true).success(function(data){
            if(data) $log.log('reordered');
              else $log.error('nope');
          });
        }
    };

    var loadedImages = 0;


    $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {



      $('#isoList').imagesLoaded()
        .always( function( instance ) {
          $('#loaderBar').fadeOut(400);
          $('#projectTitle').fadeIn(400);

        })
        .done( function( instance ) {

          $('#isoList').isotope();

          var i = 0;
          $('.box').each(function(index, el) {
            if(isScrolledIntoView($(this))) {
              var animDelay = i*200;
              $(this).delay(animDelay).animate({'opacity': 1}, 500)
              i++;
            }
          });

          $(window).scroll(function() {
            var i = 0;
            $('.box').each(function(index, el) {
              if(isScrolledIntoView($(this))) {
                if($(this).css('opacity')==0) {
                  i++;
                  var animDelay = (i-1)*200;
                  $(this).delay(animDelay).animate({'opacity': 1}, 500);
                }
              }
            });
          });

          angular.element('.swipebox').swipebox({
            loopAtEnd: true,
            removeBarsOnMobile : false
          });

        })
        .fail( function() {
          console.log('all images loaded, at least one is broken');

          $('#isoList').isotope();

          var i = 0;
          $('.box').each(function(index, el) {
            if(isScrolledIntoView($(this))) {
              var animDelay = i*200;
              $(this).delay(animDelay).animate({'opacity': 1}, 500)
              i++;
            }
          });

          $(window).scroll(function() {
            var i = 0;
            $('.box').each(function(index, el) {
              if(isScrolledIntoView($(this))) {
                if($(this).css('opacity')==0) {
                  i++;
                  var animDelay = (i-1)*200;
                  $(this).delay(animDelay).animate({'opacity': 1}, 500);
                }
              }
            });
          });

          angular.element('.swipebox').swipebox({
            loopAtEnd: true,
            removeBarsOnMobile : false
          });
        })
        .progress( function( instance, image ) {
            loadedImages++;
            $('#loaderBar').css('width', loadedImages/$scope.page.content.length*100+'%');
        });

    });

    $scope.isoOptions  = JSON.stringify({
      "percentPosition": "true",
      "transitionDuration" : "0.4s",
      "itemSelector" : ".box",
      "layoutMode": 'packery'
    });

    $scope.showSlides = function(index) {
      var content = $scope.page.children[index].content;
      var slides = [];
      for (var i = content.length - 1; i >= 0; i--) {
        slides.push({href: content[i].image_url, title: $scope.page.children[index].title});

      };
      $.swipebox(slides, {
          hideBarsDelay: 99999,
          loopAtEnd: true,
          removeBarsOnMobile : false
      });
    }

    $('body').on('click', '.slide.current', function(event) {
      event.preventDefault();
      if($(event.target).attr('src') == undefined) $('#swipebox-close').trigger('click');
    });


    $scope.dropzoneConfig = {
      parallelUploads: 3,
      maxFileSize: 30,
      url: AppSettings.apiUrl + 'file-upload',
      addedfile: function(file) {
        file.previewElement = Dropzone.createElement(this.options.previewTemplate);
      },
      thumbnail: function(file, dataUrl) {
        var elDropzone = angular.element('.thumb-dz');
        elDropzone.css('background-url', dataUrl);
      },
      success: function(file, response) {
        angular.element('.form-thumb').val(response.url);
        $scope.pageChild.fields['image'] = response.url;
        $scope.$apply();
      }
    };


    $scope.dropzoneConfig2 = {
      parallelUploads: 3,
      maxFileSize: 30,
      url: AppSettings.apiUrl + 'file-upload',
      addedfile: function(file) {
        //file.previewElement = Dropzone.createElement(this.options.previewTemplate);
      },
      thumbnail: function(file, dataUrl) {
        var elDropzone = angular.element('.thumbImage');
        elDropzone.css('background-url', dataUrl);
      },
      success: function(file, response) {
        angular.element('.form-thumb').val(response.url);
        if (typeof $scope.project.fields == 'undefined') {
          $scope.project.fields = {};
        }
        $scope.project.fields['image'] = response.url;
        for (var i = $scope.page.children.length - 1; i >= 0; i--) {
          if($scope.page.children[i].id == $scope.project.id) {
            $scope.page.children[i] = $scope.project;
          }
        };
        $scope.$apply();
        angular.element('.thumbImage').css('background-image', 'url('+response.url+')');
      }
    };


    $scope.dropzoneConfig3 = {
      parallelUploads: 3,
      maxFileSize: 30,
      url: AppSettings.apiUrl + 'file-upload',
      addedfile: function(file) {
        //file.previewElement = Dropzone.createElement(this.options.previewTemplate);
      },
      thumbnail: function(file, dataUrl) {
        var elDropzone = angular.element('.uploadPreview');
        //elDropzone.find('img').remove();
        //angular.element('<img/>').attr('src', dataUrl).appendTo(elDropzone);
      },
      success: function(file, response) {
        angular.element('.form-thumb').val(response.url);
        var item = {
          image_url: response.url
        }
        $scope.project.content.push(item);
        //angular.element('.thumb-dz').css('background-image', 'url('+response.url+')');
        $scope.$apply();
      }
    };

    $scope.deletePage = function(id){
      adminService.removeForm('page',id,$scope.accessToken).success(function(data){
        if(data) window.location.replace("#" + $scope.page.parent_url);
          else $log.error('nope');
      })
    };

    $scope.deleteContent = function(id){
      adminService.removeForm('content',id,$scope.accessToken).success(function(data){
        if(data) location.reload();
          else $log.error('nope');
      })
    };

    $scope.close = function(which,event){
      event.preventDefault();
      angular.element('.wrap').removeClass('admin-form-' + which);
      if (which == 'page') $scope.toggle = false;
    }

    $scope.adminForm = function(which, objectId) {
      var form = angular.element('.form-' + which);

      //if (which == 'page') {
        $scope.project = objectId ? _.findWhere($scope.page.children, {id: objectId}) : adminService.newPage();
        angular.element('.wrap').addClass('admin-form-' + 'project');
        $scope.toggle = true;
      //}



    };


    $scope.adminFormSave = function(which, draft) {

      var data = $scope[which];
      data.draft = !!draft;

      $log.log(data);

      var whichSave = which;

      //var loader = angular.element('.admin-form .actions, .admin-form .loader').toggleClass('hidden');

      if (which == 'pageChild') {
        whichSave = 'page';
        if (typeof data.fields['image'] == 'undefined') {
          $log.log('here');
          data.fields['image'] = 'http://maraploscaru.com/salt-api/web/uploads/thumb-5649a49edc6ca.jpg';
        }
      }
      if (which == 'project') whichSave = 'page';

      adminService.saveForm(whichSave, data, $scope.user.accessToken).success(function(savedObject) {
        //loader.toggleClass('hidden');
        //angular.element('.wrap').toggleClass('admin-form-' + which);
        $scope[which] = savedObject;
        if (which == 'pageChild') {
            //window.location.assign(window.location.origin + window.location.pathname + '#' + savedObject.url);
            $scope.page.children.push(savedObject);
            $scope[which] = {
                  url: '',
                  title: '',
                  template: 'project',
                  parent: '',
                  fields: {},
                  children: [],
                  content: [],
                  tags: ''
                };
            $scope.adminForm('page',savedObject.id)
        }

      });

    }

  })
    .directive("owlCarousel", function() {
        return {
            restrict: 'E',
            transclude: false,
            link: function (scope) {
                scope.initCarousel = function(element) {
                  // provide any default options you want
                    var defaultOptions = {
                        margin: '1',
                        loop: 'true',
                        nav: 'false',
                        //navText: ['-','+'],
                        autoplay: 'false',
                        autoWidth: 'true',
                        lazyLoad: 'true',
                        smartSpeed: '1000'
                    };
                    var customOptions = scope.$eval($(element).attr('data-options'));
                    // combine the two options objects
                    for(var key in customOptions) {
                        defaultOptions[key] = customOptions[key];
                    }
                    // init carousel
                    $(element).owlCarousel(defaultOptions);
                };
            }
        };
    })
    .directive('owlCarouselItem', [function() {
        return {
            restrict: 'A',
            transclude: false,
            link: function(scope, element) {
              // wait for the last item in the ng-repeat then call init
                if(scope.$last) {
                    scope.initCarousel(element.parent());
                }
            }
        };
    }])
  .directive('resize', function ($window) {
    return function (scope, element) {
        var w = angular.element($window);
        scope.getWindowDimensions = function () {
            return {
                'h': w.height(),
                'w': w.width()
            };
        };
        scope.$watch(scope.getWindowDimensions, function (newValue, oldValue) {
            scope.windowHeight = newValue.h;
            scope.windowWidth = newValue.w;

            scope.style = function () {
                return {
                    'height': (newValue.h) + 'px',
                    'width': (newValue.w) + 'px'
                };
            };

        }, true);

        w.bind('resize', function () {
            scope.$apply();
        });
    }
  });

'use strict';

angular.module('salt')
    .controller('MainCtrl', function ($scope, $http, $route, $routeParams, AppSettings, $log, adminService, ngMeta) {

    $scope.toggle = false;

    $scope.scrolled = $(window).scrollTop();
    $scope.showAdmin = AppSettings.showAdmin;

    $scope.user = {
        accessToken: true
    };

    $scope.pageChild = {
      url: '',
      title: '',
      template: 'page',
      parent: '',
      fields: [],
      children: [],
      content: []
    };

    function showLogo(){
      $('.logo').fadeIn('400', function() {
      });
    }

    var timeoutid = 0;
    $("body").mousemove(function() {
        clearTimeout(timeoutid);
        if(timeoutid != 0) $('.logo').fadeOut('400');
        timeoutid = setTimeout(showLogo, 5000);
    });



    $http.get(AppSettings.apiUrl + 'page/%252F').
      success(function(data, status, headers, config) {
        $scope.page = data;
        $scope.pageChild.parent = $scope.page.id;
        ngMeta.setTitle($scope.page.fields.metaTitle);
        ngMeta.setTag('description', $scope.page.fields.metaDescription);

        var bgSlider = [];

        for (var i = $scope.page.content.length - 1; i >= 0; i--) {
          bgSlider.push({src: $scope.page.content[i].image_url});
        };

        if($("body").hasClass('vegas-container')) $("body").vegas('destroy');

        $("body").vegas({
            slides: bgSlider
        });

      });


    $scope.adminFormSave = function(which, draft) {

      var data = $scope[which];
      data.draft = !!draft;

      var whichSave = which;


      if (which == 'pageChild') whichSave = 'page';

      adminService.saveForm(whichSave, data, $scope.user.accessToken).success(function(savedObject) {
        //loader.toggleClass('hidden');
        //angular.element('.wrap').toggleClass('admin-form-' + which);
        $scope[which] = savedObject;
        if (which == 'pageChild') {
            $scope.page.children.push(savedObject);
            $scope[which] = {
                  url: '',
                  title: '',
                  template: 'page',
                  parent: '',
                  fields: [],
                  children: [],
                  content: []
                };
        }

      });

    }

    $scope.dropzoneConfig = {
      parallelUploads: 3,
      maxFileSize: 30,
      url: AppSettings.apiUrl + 'file-upload',
      addedfile: function(file) {
        file.previewElement = Dropzone.createElement(this.options.previewTemplate);
      },
      thumbnail: function(file, dataUrl) {
        var elDropzone = angular.element('.uploadPreview');
        //elDropzone.find('img').remove();
        angular.element('<img/>').attr('src', dataUrl).appendTo(elDropzone);
        $log.log('here' + dataUrl);
      },
      success: function(file, response) {
        angular.element('.form-thumb').val(response.url);
        var item = {
          image_url: response.url
        }
        $scope.page.content.push(item);
        angular.element('.thumb-dz').css('background-image', 'url('+response.url+')');
      }
    };


    $scope.deleteContent = function(id){
      adminService.removeForm('content',id,$scope.accessToken).success(function(data){
        if(data) location.reload();
          else $log.error('nope');
      })
    };


    $scope.action = $route.current.$$route.action;

    })


  .directive('ngDropzone', function () {
      return {
        restrict: 'AE',
        template: '<div ng-transclude></div>',
        transclude: true,
        scope: {
          dropzone: '=',
          dropzoneConfig: '=',
          eventHandlers: '='
        },
        link: function(scope, element, attrs, ctrls) {
          try { Dropzone }
          catch (error) {
            throw new Error('Dropzone.js not loaded.');
          }

          var dropzone = new Dropzone(element[0], scope.dropzoneConfig);

          if (scope.eventHandlers) {
            Object.keys(scope.eventHandlers).forEach(function (eventName) {
              dropzone.on(eventName, scope.eventHandlers[eventName]);
            });
          }

          scope.dropzone = dropzone;
        }
      };
    });

'use strict';

angular.module('salt')
  .controller('ArtistsCtrl', function ($scope, $http, $route, $routeParams, AppSettings, $log, $timeout, adminService, ngMeta) {
    $scope.action = $route.current.$$route.action;
    $scope.pageUri = $route.current.params.project;
    $scope.user = {accessToken: true};
    $scope.menu = [];
    $scope.showAdmin = AppSettings.showAdmin;


    if($("body").hasClass('vegas-container')) $("body").vegas('destroy');

    $('.nav a').removeClass('active');
    $('.about').addClass('active');

    if($(".nav").hasClass('open')) {
      $('.nav').removeClass('open');
      $('.nav').slideToggle(400);
    }


    function showLogo(){
      $('.logo').fadeIn('400', function() {
      });
    }

    var timeoutid = 0;
    $("body").mousemove(function() {
        clearTimeout(timeoutid);
        if(timeoutid != 0) $('.logo').fadeOut('400');
        timeoutid = setTimeout(showLogo, 5000);
    });


    //get page info
    var pageUrl = encodeURIComponent(encodeURIComponent('/about'));
    $http.get(AppSettings.apiUrl + 'page/'+pageUrl).
      success(function(data, status, headers, config) {
        $scope.page = data;
        ngMeta.setTitle($scope.page.fields.metaTitle);
        ngMeta.setTag('description', $scope.page.fields.metaDescription);
        //get menu content
        $http.get(AppSettings.apiUrl + 'pages').
          success(function(data, status, headers, config) {
            $scope.menu = _.where(data, {parent: '1'});
        });
    });

    $scope.toggleMenu = function() {
        angular.element('.nav').slideToggle();
    }


    $scope.dropzoneConfig = {
      parallelUploads: 3,
      maxFileSize: 30,
      url: AppSettings.apiUrl + 'file-upload',
      addedfile: function(file) {
        file.previewElement = Dropzone.createElement(this.options.previewTemplate);
      },
      thumbnail: function(file, dataUrl) {
        var elDropzone = angular.element('.thumb-dz');
        elDropzone.css('background-url', dataUrl);
      },
      success: function(file, response) {
        angular.element('.form-thumb').val(response.url);
        $scope.page.fields['image'] = response.url;
        angular.element('.thumb-dz').css('background-image', 'url('+response.url+')');
      }
    };


    //Admin part

    $scope.adminFormSave = function(which, draft) {

      var data = $scope[which];
      $log.log(data);
      data.draft = !!draft;

      var whichSave = which;

      //var loader = angular.element('.admin-form .actions, .admin-form .loader').toggleClass('hidden');

      adminService.saveForm(whichSave, data, $scope.user.accessToken).success(function(savedObject) {
        $scope[which] = savedObject;
      });

    }
  })
  .directive('compile',function($compile, $timeout){
    return{
        restrict:'A',
        link: function(scope,elem,attrs){
            $timeout(function(){
                $compile(elem.contents())(scope);
            });
        }
    };
  });

(function() {
  'use strict';

  angular
    .module('salt')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log,ngMeta) {

    ngMeta.init();
    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('salt')
    .config(routeConfig);

  function routeConfig($routeProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'app/main/main.html',
        controller: 'MainCtrl',
        action: 'index'
      })
      .when('/page/:page', {
        templateUrl: 'app/page/page.html',
        controller: 'PageCtrl',
        action: 'page'
      })
      .when('/project/:project', {
        templateUrl: 'app/project/project.html', 
        controller: 'ProjectCtrl',
        action: 'project'
      })
      .when('/tag/:tag', {
        templateUrl: 'app/tag/tag.html',
        controller: 'TagCtrl',
        action: 'tag'
      })
      .when('/about', {
        templateUrl: 'app/about/about.html',
        controller: 'ArtistsCtrl',
        action: 'artists'
      })
      .when('/rental', {
        templateUrl: 'app/rental/rental.html',
        controller: 'RentalCtrl',
        action: 'rental'
      })
      .otherwise({
        redirectTo: '/'
      });
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('salt')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
	.constant('AppSettings', {
      apiUrl: 'http://zigzagarchitecture.ro/api/web/index.php/',
      showAdmin: false
	});
})();

(function() {
  'use strict';

  angular
    .module('salt')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();


/*! url - v1.8.6 - 2013-11-22 */window.url=function(){function a(a){return!isNaN(parseFloat(a))&&isFinite(a)}return function(b,c){var d=c||window.location.toString();if(!b)return d;b=b.toString(),"//"===d.substring(0,2)?d="http:"+d:1===d.split("://").length&&(d="http://"+d),c=d.split("/");var e={auth:""},f=c[2].split("@");1===f.length?f=f[0].split(":"):(e.auth=f[0],f=f[1].split(":")),e.protocol=c[0],e.hostname=f[0],e.port=f[1]||("https"===e.protocol.split(":")[0].toLowerCase()?"443":"80"),e.pathname=(c.length>3?"/":"")+c.slice(3,c.length).join("/").split("?")[0].split("#")[0];var g=e.pathname;"/"===g.charAt(g.length-1)&&(g=g.substring(0,g.length-1));var h=e.hostname,i=h.split("."),j=g.split("/");if("hostname"===b)return h;if("domain"===b)return/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(h)?h:i.slice(-2).join(".");if("sub"===b)return i.slice(0,i.length-2).join(".");if("port"===b)return e.port;if("protocol"===b)return e.protocol.split(":")[0];if("auth"===b)return e.auth;if("user"===b)return e.auth.split(":")[0];if("pass"===b)return e.auth.split(":")[1]||"";if("path"===b)return e.pathname;if("."===b.charAt(0)){if(b=b.substring(1),a(b))return b=parseInt(b,10),i[0>b?i.length+b:b-1]||""}else{if(a(b))return b=parseInt(b,10),j[0>b?j.length+b:b]||"";if("file"===b)return j.slice(-1)[0];if("filename"===b)return j.slice(-1)[0].split(".")[0];if("fileext"===b)return j.slice(-1)[0].split(".")[1]||"";if("?"===b.charAt(0)||"#"===b.charAt(0)){var k=d,l=null;if("?"===b.charAt(0)?k=(k.split("?")[1]||"").split("#")[0]:"#"===b.charAt(0)&&(k=k.split("#")[1]||""),!b.charAt(1))return k;b=b.substring(1),k=k.split("&");for(var m=0,n=k.length;n>m;m++)if(l=k[m].split("="),l[0]===b)return l[1]||"";return null}}return""}}(),"undefined"!=typeof jQuery&&jQuery.extend({url:function(a,b){return window.url(a,b)}});

/*!
 * Packery layout mode PACKAGED v1.1.3
 * sub-classes Packery
 * http://packery.metafizzy.co
 */

!function(a){function b(a){return new RegExp("(^|\\s+)"+a+"(\\s+|$)")}function c(a,b){var c=d(a,b)?f:e;c(a,b)}var d,e,f;"classList"in document.documentElement?(d=function(a,b){return a.classList.contains(b)},e=function(a,b){a.classList.add(b)},f=function(a,b){a.classList.remove(b)}):(d=function(a,c){return b(c).test(a.className)},e=function(a,b){d(a,b)||(a.className=a.className+" "+b)},f=function(a,c){a.className=a.className.replace(b(c)," ")});var g={hasClass:d,addClass:e,removeClass:f,toggleClass:c,has:d,add:e,remove:f,toggle:c};"function"==typeof define&&define.amd?define("classie/classie",g):"object"==typeof exports?module.exports=g:a.classie=g}(window),function(a,b){"function"==typeof define&&define.amd?define("packery/js/rect",b):"object"==typeof exports?module.exports=b():(a.Packery=a.Packery||{},a.Packery.Rect=b())}(window,function(){function a(b){for(var c in a.defaults)this[c]=a.defaults[c];for(c in b)this[c]=b[c]}var b=window.Packery=function(){};return b.Rect=a,a.defaults={x:0,y:0,width:0,height:0},a.prototype.contains=function(a){var b=a.width||0,c=a.height||0;return this.x<=a.x&&this.y<=a.y&&this.x+this.width>=a.x+b&&this.y+this.height>=a.y+c},a.prototype.overlaps=function(a){var b=this.x+this.width,c=this.y+this.height,d=a.x+a.width,e=a.y+a.height;return this.x<d&&b>a.x&&this.y<e&&c>a.y},a.prototype.getMaximalFreeRects=function(b){if(!this.overlaps(b))return!1;var c,d=[],e=this.x+this.width,f=this.y+this.height,g=b.x+b.width,h=b.y+b.height;return this.y<b.y&&(c=new a({x:this.x,y:this.y,width:this.width,height:b.y-this.y}),d.push(c)),e>g&&(c=new a({x:g,y:this.y,width:e-g,height:this.height}),d.push(c)),f>h&&(c=new a({x:this.x,y:h,width:this.width,height:f-h}),d.push(c)),this.x<b.x&&(c=new a({x:this.x,y:this.y,width:b.x-this.x,height:this.height}),d.push(c)),d},a.prototype.canFit=function(a){return this.width>=a.width&&this.height>=a.height},a}),function(a,b){if("function"==typeof define&&define.amd)define("packery/js/packer",["./rect"],b);else if("object"==typeof exports)module.exports=b(require("./rect"));else{var c=a.Packery=a.Packery||{};c.Packer=b(c.Rect)}}(window,function(a){function b(a,b,c){this.width=a||0,this.height=b||0,this.sortDirection=c||"downwardLeftToRight",this.reset()}b.prototype.reset=function(){this.spaces=[],this.newSpaces=[];var b=new a({x:0,y:0,width:this.width,height:this.height});this.spaces.push(b),this.sorter=c[this.sortDirection]||c.downwardLeftToRight},b.prototype.pack=function(a){for(var b=0,c=this.spaces.length;c>b;b++){var d=this.spaces[b];if(d.canFit(a)){this.placeInSpace(a,d);break}}},b.prototype.placeInSpace=function(a,b){a.x=b.x,a.y=b.y,this.placed(a)},b.prototype.placed=function(a){for(var b=[],c=0,d=this.spaces.length;d>c;c++){var e=this.spaces[c],f=e.getMaximalFreeRects(a);f?b.push.apply(b,f):b.push(e)}this.spaces=b,this.mergeSortSpaces()},b.prototype.mergeSortSpaces=function(){b.mergeRects(this.spaces),this.spaces.sort(this.sorter)},b.prototype.addSpace=function(a){this.spaces.push(a),this.mergeSortSpaces()},b.mergeRects=function(a){for(var b=0,c=a.length;c>b;b++){var d=a[b];if(d){var e=a.slice(0);e.splice(b,1);for(var f=0,g=0,h=e.length;h>g;g++){var i=e[g],j=b>g?0:1;d.contains(i)&&(a.splice(g+j-f,1),f++)}}}return a};var c={downwardLeftToRight:function(a,b){return a.y-b.y||a.x-b.x},rightwardTopToBottom:function(a,b){return a.x-b.x||a.y-b.y}};return b}),function(a,b){"function"==typeof define&&define.amd?define("packery/js/item",["get-style-property/get-style-property","outlayer/outlayer","./rect"],b):"object"==typeof exports?module.exports=b(require("desandro-get-style-property"),require("outlayer"),require("./rect")):a.Packery.Item=b(a.getStyleProperty,a.Outlayer,a.Packery.Rect)}(window,function(a,b,c){var d=a("transform"),e=function(){b.Item.apply(this,arguments)};e.prototype=new b.Item;var f=e.prototype._create;return e.prototype._create=function(){f.call(this),this.rect=new c,this.placeRect=new c},e.prototype.dragStart=function(){this.getPosition(),this.removeTransitionStyles(),this.isTransitioning&&d&&(this.element.style[d]="none"),this.getSize(),this.isPlacing=!0,this.needsPositioning=!1,this.positionPlaceRect(this.position.x,this.position.y),this.isTransitioning=!1,this.didDrag=!1},e.prototype.dragMove=function(a,b){this.didDrag=!0;var c=this.layout.size;a-=c.paddingLeft,b-=c.paddingTop,this.positionPlaceRect(a,b)},e.prototype.dragStop=function(){this.getPosition();var a=this.position.x!=this.placeRect.x,b=this.position.y!=this.placeRect.y;this.needsPositioning=a||b,this.didDrag=!1},e.prototype.positionPlaceRect=function(a,b,c){this.placeRect.x=this.getPlaceRectCoord(a,!0),this.placeRect.y=this.getPlaceRectCoord(b,!1,c)},e.prototype.getPlaceRectCoord=function(a,b,c){var d=b?"Width":"Height",e=this.size["outer"+d],f=this.layout[b?"columnWidth":"rowHeight"],g=this.layout.size["inner"+d];b||(g=Math.max(g,this.layout.maxY),this.layout.rowHeight||(g-=this.layout.gutter));var h;if(f){f+=this.layout.gutter,g+=b?this.layout.gutter:0,a=Math.round(a/f);var i;i=this.layout.options.isHorizontal?b?"ceil":"floor":b?"floor":"ceil";var j=Math[i](g/f);j-=Math.ceil(e/f),h=j}else h=g-e;return a=c?a:Math.min(a,h),a*=f||1,Math.max(0,a)},e.prototype.copyPlaceRectPosition=function(){this.rect.x=this.placeRect.x,this.rect.y=this.placeRect.y},e.prototype.removeElem=function(){this.element.parentNode.removeChild(this.element),this.layout.packer.addSpace(this.rect),this.emitEvent("remove",[this])},e}),function(a,b){"function"==typeof define&&define.amd?define("packery/js/packery",["classie/classie","get-size/get-size","outlayer/outlayer","./rect","./packer","./item"],b):"object"==typeof exports?module.exports=b(require("desandro-classie"),require("get-size"),require("outlayer"),require("./rect"),require("./packer"),require("./item")):a.Packery=b(a.classie,a.getSize,a.Outlayer,a.Packery.Rect,a.Packery.Packer,a.Packery.Item)}(window,function(a,b,c,d,e,f){function g(a,b){return a.position.y-b.position.y||a.position.x-b.position.x}function h(a,b){return a.position.x-b.position.x||a.position.y-b.position.y}d.prototype.canFit=function(a){return this.width>=a.width-1&&this.height>=a.height-1};var i=c.create("packery");return i.Item=f,i.prototype._create=function(){c.prototype._create.call(this),this.packer=new e,this.stamp(this.options.stamped);var a=this;this.handleDraggabilly={dragStart:function(){a.itemDragStart(this.element)},dragMove:function(){a.itemDragMove(this.element,this.position.x,this.position.y)},dragEnd:function(){a.itemDragEnd(this.element)}},this.handleUIDraggable={start:function(b){a.itemDragStart(b.currentTarget)},drag:function(b,c){a.itemDragMove(b.currentTarget,c.position.left,c.position.top)},stop:function(b){a.itemDragEnd(b.currentTarget)}}},i.prototype._resetLayout=function(){this.getSize(),this._getMeasurements();var a=this.packer;this.options.isHorizontal?(a.width=Number.POSITIVE_INFINITY,a.height=this.size.innerHeight+this.gutter,a.sortDirection="rightwardTopToBottom"):(a.width=this.size.innerWidth+this.gutter,a.height=Number.POSITIVE_INFINITY,a.sortDirection="downwardLeftToRight"),a.reset(),this.maxY=0,this.maxX=0},i.prototype._getMeasurements=function(){this._getMeasurement("columnWidth","width"),this._getMeasurement("rowHeight","height"),this._getMeasurement("gutter","width")},i.prototype._getItemLayoutPosition=function(a){return this._packItem(a),a.rect},i.prototype._packItem=function(a){this._setRectSize(a.element,a.rect),this.packer.pack(a.rect),this._setMaxXY(a.rect)},i.prototype._setMaxXY=function(a){this.maxX=Math.max(a.x+a.width,this.maxX),this.maxY=Math.max(a.y+a.height,this.maxY)},i.prototype._setRectSize=function(a,c){var d=b(a),e=d.outerWidth,f=d.outerHeight;(e||f)&&(e=this._applyGridGutter(e,this.columnWidth),f=this._applyGridGutter(f,this.rowHeight)),c.width=Math.min(e,this.packer.width),c.height=Math.min(f,this.packer.height)},i.prototype._applyGridGutter=function(a,b){if(!b)return a+this.gutter;b+=this.gutter;var c=a%b,d=c&&1>c?"round":"ceil";return a=Math[d](a/b)*b},i.prototype._getContainerSize=function(){return this.options.isHorizontal?{width:this.maxX-this.gutter}:{height:this.maxY-this.gutter}},i.prototype._manageStamp=function(a){var b,c=this.getItem(a);if(c&&c.isPlacing)b=c.placeRect;else{var e=this._getElementOffset(a);b=new d({x:this.options.isOriginLeft?e.left:e.right,y:this.options.isOriginTop?e.top:e.bottom})}this._setRectSize(a,b),this.packer.placed(b),this._setMaxXY(b)},i.prototype.sortItemsByPosition=function(){var a=this.options.isHorizontal?h:g;this.items.sort(a)},i.prototype.fit=function(a,b,c){var d=this.getItem(a);d&&(this._getMeasurements(),this.stamp(d.element),d.getSize(),d.isPlacing=!0,b=void 0===b?d.rect.x:b,c=void 0===c?d.rect.y:c,d.positionPlaceRect(b,c,!0),this._bindFitEvents(d),d.moveTo(d.placeRect.x,d.placeRect.y),this.layout(),this.unstamp(d.element),this.sortItemsByPosition(),d.isPlacing=!1,d.copyPlaceRectPosition())},i.prototype._bindFitEvents=function(a){function b(){d++,2==d&&c.emitEvent("fitComplete",[a])}var c=this,d=0;a.on("layout",function(){return b(),!0}),this.on("layoutComplete",function(){return b(),!0})},i.prototype.resize=function(){var a=b(this.element),c=this.size&&a,d=this.options.isHorizontal?"innerHeight":"innerWidth";c&&a[d]==this.size[d]||this.layout()},i.prototype.itemDragStart=function(a){this.stamp(a);var b=this.getItem(a);b&&b.dragStart()},i.prototype.itemDragMove=function(a,b,c){function d(){f.layout(),delete f.dragTimeout}var e=this.getItem(a);e&&e.dragMove(b,c);var f=this;this.clearDragTimeout(),this.dragTimeout=setTimeout(d,40)},i.prototype.clearDragTimeout=function(){this.dragTimeout&&clearTimeout(this.dragTimeout)},i.prototype.itemDragEnd=function(b){var c,d=this.getItem(b);if(d&&(c=d.didDrag,d.dragStop()),!d||!c&&!d.needsPositioning)return void this.unstamp(b);a.add(d.element,"is-positioning-post-drag");var e=this._getDragEndLayoutComplete(b,d);d.needsPositioning?(d.on("layout",e),d.moveTo(d.placeRect.x,d.placeRect.y)):d&&d.copyPlaceRectPosition(),this.clearDragTimeout(),this.on("layoutComplete",e),this.layout()},i.prototype._getDragEndLayoutComplete=function(b,c){var d=c&&c.needsPositioning,e=0,f=d?2:1,g=this;return function(){return e++,e!=f?!0:(c&&(a.remove(c.element,"is-positioning-post-drag"),c.isPlacing=!1,c.copyPlaceRectPosition()),g.unstamp(b),g.sortItemsByPosition(),d&&g.emitEvent("dragItemPositioned",[c]),!0)}},i.prototype.bindDraggabillyEvents=function(a){a.on("dragStart",this.handleDraggabilly.dragStart),a.on("dragMove",this.handleDraggabilly.dragMove),a.on("dragEnd",this.handleDraggabilly.dragEnd)},i.prototype.bindUIDraggableEvents=function(a){a.on("dragstart",this.handleUIDraggable.start).on("drag",this.handleUIDraggable.drag).on("dragstop",this.handleUIDraggable.stop)},i.Rect=d,i.Packer=e,i}),function(a,b){"function"==typeof define&&define.amd?define(["isotope/js/layout-mode","packery/js/packery","get-size/get-size"],b):"object"==typeof exports?module.exports=b(require("isotope-layout/js/layout-mode"),require("packery"),require("get-size")):b(a.Isotope.LayoutMode,a.Packery,a.getSize)}(window,function(a,b,c){function d(a,b){for(var c in b)a[c]=b[c];return a}var e=a.create("packery"),f=e.prototype._getElementOffset,g=e.prototype._getMeasurement;d(e.prototype,b.prototype),e.prototype._getElementOffset=f,e.prototype._getMeasurement=g;var h=e.prototype._resetLayout;e.prototype._resetLayout=function(){this.packer=this.packer||new b.Packer,h.apply(this,arguments)};var i=e.prototype._getItemLayoutPosition;e.prototype._getItemLayoutPosition=function(a){return a.rect=a.rect||new b.Rect,i.call(this,a)};var j=e.prototype._manageStamp;return e.prototype._manageStamp=function(){this.options.isOriginLeft=this.isotope.options.isOriginLeft,this.options.isOriginTop=this.isotope.options.isOriginTop,j.apply(this,arguments)},e.prototype.needsResizeLayout=function(){var a=c(this.element),b=this.size&&a,d=this.options.isHorizontal?"innerHeight":"innerWidth";return b&&a[d]!=this.size[d]},e});
angular.module("salt").run(["$templateCache", function($templateCache) {$templateCache.put("app/about/about.html","<div id=admin ng-class=\"{\'active\' : toggle}\" ng-if=\"showAdmin == true\"><button id=showAdmin ng-click=\"toggle = !toggle\">+</button><div id=adminContent style=\"height: {{windowHeight}}px\"><div class=form-page><label for=meta-title>Meta title</label><input id=meta-title type=text ng-model=page.fields.metaTitle><label for=meta-description>Meta description</label><textarea id=meta-description ng-model=page.fields.metaDescription placeholder=\"Text here for google search\"></textarea><label>Content</label><text-angular style=\"height: 50px\" ng-model=page.fields.desc ta-toolbar=\"[[\'h2\',\'insertLink\',\'html\']]\"></text-angular><input type=hidden class=form-thumb ng-model=page.fields.image><form class=\"dropzone thumb-dz\" method=post enctype=multipart/form-data ng-dropzone dropzone=dropzone dropzone-config=dropzoneConfig style=\"background-image: url({{ page.fields.image || \'../assets/images/thumb.png\' }})\"><div class=dz-message><button>Add image</button></div></form><button ng-click=\"adminFormSave(\'page\')\">Save</button></div></div></div><div class=\"wrap page-{{ action }}\"><div class=text><img ng-src={{page.fields.image}} alt=\"\"><div compile ng-bind-html=page.fields.desc></div></div></div><div ng-include=\"\'app/components/navbar/navbar.html\'\"></div>");
$templateCache.put("app/main/main.html","<div id=admin ng-class=\"{\'active\' : toggle}\" scroll ng-if=\"showAdmin == true\"><button id=showAdmin ng-click=\"toggle = !toggle\">+</button><div id=adminContent style=\"height: {{windowHeight}}px\"><div class=form-page><label for=meta-title>Meta title</label><input id=meta-title type=text ng-model=page.fields.metaTitle><label for=meta-description>Meta description</label><textarea id=meta-description ng-model=page.fields.metaDescription placeholder=\"Text here for google search\"></textarea><div class=uploadPreview></div><hr><label>Pictures</label><form class=\"dropzone thumb-dz\" method=post enctype=multipart/form-data ng-dropzone dropzone=dropzone dropzone-config=dropzoneConfig><div class=dz-message><button>Browse</button></div></form><div class=imagesContainer data-as-sortable=dragControlListeners data-ng-model=page.content><div class=imageItem ng-repeat=\"image in page.content\" data-as-sortable-item style=\"background-image: url({{image.image_url}})\"><div data-as-sortable-item-handle></div><button ng-click=deleteContent(image.id)>X</button></div></div><button ng-click=\"adminFormSave(\'page\')\">Save</button><br><button ng-click=\"toggleChild = !toggleChild\">+Add folder</button><div id=addProject ng-class=\"{\'active\' : toggleChild}\"><label for=childName>Nume</label><input type=text ng-model=pageChild.title id=childName> <input type=hidden ng-model=pageChild.parent> <button ng-click=\"adminFormSave(\'pageChild\')\">Add</button></div></div></div></div><div class=\"wrap page-{{ action }}\"></div><div ng-include=\"\'app/components/navbar/navbar.html\'\"></div>");
$templateCache.put("app/page/page.html","<div class=\"wrap page-{{ action }}\"><div id=admin ng-class=\"{\'active\' : toggle}\" ng-if=\"showAdmin == true\"><button id=showAdmin ng-click=\"toggle = !toggle\">+</button><div id=adminContent style=\"height: {{windowHeight}}px\"><div class=form-page><a href=# ng-click=\"close(\'page\',$event)\" class=close>X</a><label for=titlu>Folder name</label><input type=text name=titlu ng-model=page.title id=titlu> <input type=hidden ng-model=page.id><label for=meta-title>Meta title</label><input id=meta-title type=text ng-model=page.fields.metaTitle><label for=meta-description>Meta description</label><textarea id=meta-description ng-model=page.fields.metaDescription placeholder=\"Text here for google search\"></textarea><button ng-click=\"adminFormSave(\'page\')\">Save</button> <button ng-click=deletePage(page.id)>Delete page</button><hr><button ng-click=\"toggleChild = !toggleChild\">Add new project</button><br><br><div id=addProject ng-class=\"{\'active\' : toggleChild}\"><label for=childName>Name</label><input type=text ng-model=pageChild.title id=childName><br><br><input type=hidden class=form-thumb ng-model=pageChild.fields.image><form class=\"dropzone thumb-dz\" method=post enctype=multipart/form-data ng-dropzone dropzone=dropzone dropzone-config=dropzoneConfig style=\"background-image: url({{ pageChild.fields.image || \'../assets/images/thumb.png\' }})\"><div class=dz-message><button>Add thumbnail</button></div></form><input type=hidden ng-model=pageChild.parent> <button ng-click=\"adminFormSave(\'pageChild\')\">Add</button> <button ng-click=\"toggleChild = !toggleChild\">Cancel</button></div><label>Sort projects</label><div class=imagesContainer data-as-sortable=dragControlListeners data-ng-model=page.children><div class=imageItem ng-repeat=\"project in page.children\" data-as-sortable-item style=\"background-image: url({{project.fields.image}})\"><div data-as-sortable-item-handle></div></div></div></div><div class=form-project><a href=# ng-click=\"close(\'project\',$event)\" class=close>X</a><label for=titlu>Project name</label><input type=text name=titlu ng-model=project.title id=titlu> <input type=hidden ng-model=project.id><hr><label>Thumbnail</label><form class=\"dropzone thumbImage\" style=\"background-image:url({{project.fields[\'image\']}})\" method=post enctype=multipart/form-data ng-dropzone dropzone=dropzone dropzone-config=dropzoneConfig2><div class=dz-message><button>Browse</button></div></form><div class=uploadPreview></div><hr><label>Pictures</label><form class=\"dropzone thumb-dz\" method=post enctype=multipart/form-data ng-dropzone dropzone=dropzone dropzone-config=dropzoneConfig3><div class=dz-message><button>Browse</button></div></form><div class=imagesContainer data-as-sortable=dragControlListeners data-ng-model=project.content><div class=imageItem ng-repeat=\"image in project.content\" data-as-sortable-item style=\"background-image: url({{image.image_url}})\"><div data-as-sortable-item-handle></div><button ng-if=image.id ng-click=deleteContent(image.id)>X</button></div></div><div class=clearfix></div><button ng-click=\"adminFormSave(\'project\',project.id)\">Save</button> <button ng-click=deletePage(project.id)>Delete project</button></div></div></div><div id=loaderBar></div><div isotope-container iso-options={{isoOptions}} id=isoList><div ng-repeat=\"project in page.children\" ng-class=\"{\'box\':true, \'empty\': project.fields.image == \'\', \'masonry-brick\': true}\" on-finish-render=ngRepeatFinished isotope-item=isotope-item on-finish-render=ngRepeatFinished><span ng-if=\"showAdmin == true\" class=edit ng-click=\"adminForm(\'page\',project.id); $event.stopPropagation();\">Edit</span> <a ng-click=showSlides($index)><img ng-src={{project.fields.image}} alt=\"\"><div class=bg></div></a><div class=text>{{project.title}}</div></div></div><!--\n  <div ng-repeat=\"project in page.children\" ng-class=\"{\'box\':true, \'empty\': project.fields.image == \'\'}\" on-finish-render=\"ngRepeatFinished\">\n    <span class=\"edit\" ng-click=\"adminForm(\'page\',project.id); $event.stopPropagation();\">Edit</span>\n    <a ng-href=\"#{{project.url}}\">\n      <img ng-src=\"{{project.fields.image}}\" alt=\"\">\n    </a>\n    <div class=\"text\">{{project.title}}</div>\n  </div>\n--></div><div ng-include=\"\'app/components/navbar/navbar.html\'\"></div>");
$templateCache.put("app/project/project.html","<div id=loaderBar></div><div class=\"wrap page-{{ action }}\"><!--<div class=\"dropzone-thumbnail images-loaded owl-carousel\"  on-finish-render=\"ngRepeatFinished\" images-loaded-events=\"imgLoadedEvents\">--><div class=landscape-mode>Please turn your phone to view in landscape mode.</div><div id=projectTitle>{{page.title}}</div><a href=#{{page.parent_url}} id=closeSlider>X</a><div resize class=\"dropzone-thumbnail owl-carousel\" style=\"height: {{windowHeight}}px\" images-loaded-events=imgLoadedEvents><div class=item ng-repeat=\"image in page.content\" on-finish-render=ngRepeatFinished><img ng-src={{image.image_url}} style=\"height: {{windowHeight}}px\"></div></div></div><div ng-include=\"\'app/components/navbar/navbar.html\'\"></div>");
$templateCache.put("app/tag/tag.html","<div class=\"wrap page-{{ action }}\"><ul class=nav><li ng-repeat=\"item in menu\"><a href=#{{item.url}}>{{item.title}}</a></li></ul><a class=toggle ng-click=toggleMenu()>{{tag}}</a> <a ng-repeat=\"project in projects\" href=#{{project.url}} style=background-image:url({{project.fields.image}}) class=box><div class=inner style=background-image:url({{project.fields.image}})></div><div class=text>{{project.title}}</div></a></div><div ng-include=\"\'app/components/navbar/navbar.html\'\"></div>");
$templateCache.put("app/rental/rental.html","<div id=admin ng-class=\"{\'active\' : toggle}\" ng-if=\"showAdmin == true\"><button id=showAdmin ng-click=\"toggle = !toggle\">+</button><div id=adminContent style=\"height: {{windowHeight}}px\"><div class=form-page><label>Content</label><text-angular style=\"height: 50px\" ng-model=page.fields.desc ta-toolbar=\"[[\'h2\',\'h3\',\'insertLink\',\'html\']]\"></text-angular><label for=meta-title>Meta title</label><input id=meta-title type=text ng-model=page.fields.metaTitle><label for=meta-description>Meta description</label><textarea id=meta-description ng-model=page.fields.metaDescription placeholder=\"Text here for google search\"></textarea><button ng-click=\"adminFormSave(\'page\')\">Save</button></div></div></div><div class=\"wrap page-{{ action }}\"><div class=text><div compile ng-bind-html=page.fields.desc></div></div></div><div ng-include=\"\'app/components/navbar/navbar.html\'\"></div>");
$templateCache.put("app/components/navbar/navbar.html","<div class=nav-container ng-controller=NavbarCtrl><ul class=nav><li ng-repeat=\"folder in $storage.menu\" class=page-{{folder.id}}><a href=#{{folder.url}}>{{folder.title}}</a></li><li><a class=about href=#/about>About</a></li></ul><a class=menu-button ng-click=toggleMenu()>Menu</a></div>");}]);